import ErrorBoundary from 'shared/components/ErrorBoundary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion  from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { PropTypes } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ProductCardContainer from '../containers/ProductCardContainer';
import styles from './styles.css';

const muiStyles = theme => ({
	// Override the ProductCard styles for Related Products
	productCardStyle: {
		height: '110px',
		cursor: 'pointer',
		marginRight: '3px',
		marginBottom: '21px',
		marginTop: '3px',
	},

	titleStyle: {
		[theme.breakpoints.up('xs')]: {
			fontSize: '0.6em',
		},

		[theme.breakpoints.up('sm')]: {
			fontSize: '0.65em',
		},

		[theme.breakpoints.up('xl')]: {
			fontSize: '0.7em',
		},
	},

	priceStyle: {
		fontSize: '0.8em',
	},

	subtitleStyle: {
		fontSize: '0.8em',
	},

	relatedProduct: {
		width: '50%',

		[theme.breakpoints.up('md')]: {
			width: '32%',
		},
	},
});

const RelatedProducts = ({ categoryId, relatedProducts, classes, title }) => {
	// Create a new classes object to pass/override just the RelatedProducts styling classes into ProductCard
	const productCardClasses = {
		productCardStyle: classes.productCardStyle,
		titleStyle: classes.titleStyle,
		priceStyle: classes.priceStyle,
		subtitleStyle: classes.subtitleStyle,
	};
	const items = [];
	relatedProducts.forEach(relProduct =>
		items.push(
			<div key={relProduct.id} className={classes.relatedProduct}>
				<ProductCardContainer
					categoryId={categoryId}
					id={relProduct.id}
					name={relProduct.name}
					pictureUrl={relProduct.pictureUrl}
					price={relProduct.price}
					msrp={relProduct.msrp}
					oldPrice={relProduct.oldPrice}
					sku={relProduct.sku}
					classes={productCardClasses}
				/>
			</div>,
		),
	);

	return (
		<ErrorBoundary>
			<div className={styles['product-expandable-spacer']}>
				<Accordion>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography variant="subtitle2">{title}</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<div className={styles['related-products-div']}>{items}</div>
					</AccordionDetails>
				</Accordion>
			</div>
		</ErrorBoundary>
	);
};

RelatedProducts.propTypes = {
	categoryId: PropTypes.string,
	relatedProducts: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string,
			pictureUrl: PropTypes.string,
			price: PropTypes.number,
			sku: PropTypes.string,
		}),
	).isRequired,
	classes: PropTypes.shape({
		productCardStyle: PropTypes.string,
		titleStyle: PropTypes.string,
		priceStyle: PropTypes.string,
		subtitleStyle: PropTypes.string,
		relatedProduct: PropTypes.string,
	}).isRequired,
	title: PropTypes.string,
};

RelatedProducts.defaultProps = {
	categoryId: '',
	title: 'Related Products',
};

export default withStyles(muiStyles, { name: 'RelatedProducts' })(RelatedProducts);
